import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";
import vBlur from "v-blur";
import VueAnalytics from "vue-analytics";
import { store } from "@/store";
import VueI18n from "vue-i18n";
import Clipboard from "v-clipboard";

// Plugins
import App from "./App.vue";
import Chartist from "chartist";
import Datetime from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";

// router setup
import routes from "./routes/routes";
import { sync } from "vuex-router-sync";
//import VueSocketIO from "vue-socket.io";

import { languages } from "./locales/index.js";

// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(vBlur);
Vue.use(Datetime);
Vue.use(VueI18n);
Vue.use(Clipboard);

const messages = Object.assign(languages);
var locale = window.localStorage.getItem("locale");
export const i18n = new VueI18n({
  locale: locale ? locale : "en",
  fallbackLocale: "en",
  messages
});
/*
if (
  window.location.hostname === "localhost" ||
  window.location.hostname === "test.rpaswilco.com"
) {
  Vue.use(
    new VueSocketIO({
      debug: true,
      connection: ROOT_URL
    })
  );
}
*/
if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

// configure router
export const router = new VueRouter({
  routes, // short for routes: routes
  linkExactActiveClass: "nav-item active",
  scrollBehavior: to => {
    if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});

const NO_AUTHORIZATION_URL_PATH = [
  "/",
  "/login",
  "/signup",
  "/pricing",
  "/ContactUs",
  "/product",
  "/tnc",
  "/privacy",
];

// check authorization
router.beforeEach((to, from, next) => {
  if (
    NO_AUTHORIZATION_URL_PATH.indexOf(to.path) === -1 &&
    !store.state.auth.email
  ) {
    store.dispatch("auth/getUserProfile");
    next();
  } else {
    next();
  }
});

Vue.use(VueAnalytics, {
  id: "UA-144092647-1",
  router
});

sync(store, router);

// global library setup
Object.defineProperty(Vue.prototype, "$Chartist", {
  get() {
    return this.$root.Chartist;
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  i18n,
  store,
  data: {
    Chartist: Chartist
  }
});
